/* Gallery wall set — add-all-to-cart.
 *
 * Delegated handler for any [data-gw-add] button (works for both server-rendered
 * sections and the JS-hydrated /pages/gallery-wall preview). Reads:
 *   data-gw-variants  — comma-separated Shopify variant ids (the set's pieces)
 *   data-gw-fallback  — a /cart permalink to fall back to if AJAX fails
 *   [data-gw-add-text] — optional child whose text shows the Adding…/Added state
 *
 * Adds all pieces in one POST /cart/add.js, then opens the cart drawer
 * (ArthausCart.openWithItem) — matching the rest of the theme's add-to-cart UX.
 */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gw-add]');
    if (!btn) return;
    e.preventDefault();

    var ids = (btn.getAttribute('data-gw-variants') || '')
      .split(',').map(function (s) { return parseInt(s, 10); }).filter(Boolean);
    var fallback = btn.getAttribute('data-gw-fallback') || '/cart';
    if (!ids.length) { window.location.href = fallback; return; }

    var label = btn.querySelector('[data-gw-add-text]') || btn;
    var orig = label.textContent;
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        label.textContent = 'Added ✓';
        if (window.ArthausCart && typeof window.ArthausCart.openWithItem === 'function') {
          window.ArthausCart.openWithItem();
        } else {
          window.location.href = '/cart';
        }
        setTimeout(function () { label.textContent = orig; btn.removeAttribute('aria-busy'); }, 1800);
      })
      .catch(function (err) {
        if (window.console) console.warn('[gallery-set-cart]', err);
        window.location.href = fallback; // /cart permalink still adds the items
      });
  });
})();
